import { useEffect } from 'react';
import { doc, setDoc } from 'firebase/firestore';
import { db } from '@shared/services/firebase';

/**
 * Detects the user's IANA timezone and persists it to Firestore so Cloud
 * Functions can use the correct local date when replenishing daily content.
 * Best-effort: silently ignores errors so the app continues working normally.
 */
export function useTimezoneSync(uid: string | null) {
    useEffect(() => {
        if (!uid) return;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        setDoc(doc(db, 'userContent', uid), { timezone: tz }, { merge: true })
            .catch(() => {}); // Best-effort, silent fail
    }, [uid]);
}
